export default __webpack_public_path__ + "static/media/books_dark.05fae589.png";